function InitScrollToTopButton() {
  const sttButton = document.getElementById('stt-button') as (HTMLButtonElement | null)

  if (!sttButton) return

  window.addEventListener('scroll', () => {
    if (scrollY === 0 && !sttButton.classList.contains('on-top')) {
      sttButton.classList.add('on-top')
      sttButton.disabled = true;
    } else {
      sttButton.classList.remove('on-top')
      sttButton.disabled = false;
    }
  })

  sttButton.addEventListener('click', () => {
    window.scrollTo({top: 0, behavior: "smooth"})
    const firstElement = document.querySelector<HTMLElement>(
      'a[href], button, input, textarea, select, [tabindex]:not([tabindex="-1"])'
    );
    firstElement?.focus();
  })
}

InitScrollToTopButton()
